import { createSlice } from "@reduxjs/toolkit";

export const NetworkError = createSlice({
  name: "network_error",
  initialState: {
    value: {
      status: false,
      newtorkError: false,
    },
  },
  reducers: {
    onNetworkError: (state, action) => {
      state.value.newtorkError = true;
    },
    closeNetworkError: (state, action) => {
      state.value.newtorkError = action.payload;
    },
  },
});

export const { onNetworkError, closeNetworkError } = NetworkError.actions;

export default NetworkError.reducer;
